// app/javascript/controllers/toolbar_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // connect() {
  //   this.element.addEventListener("submit", this.handleSubmit.bind(this));
  // }
  // handleSubmit(event) {
  //   event.preventDefault();
  //   // Disable all empty inputs
  //   this.element.querySelectorAll("input").forEach((input) => {
  //     if (input.value === "") {
  //       input.disabled = true;
  //     }
  //   });
  //   // Submit the form
  //   this.element.submit();
  //   // Re-enable inputs for future submissions
  //   this.element.querySelectorAll("input:disabled").forEach((input) => {
  //     input.disabled = false;
  //   });
  // }
}
